import React from 'react';
import './TabBar.less';

/**
 * 可选参数
 */
interface IProps {
	list: string[];
	select: number;
	onChange?: any;
}

/**
 * 页眉
 */
class TabBar extends React.PureComponent<IProps> {
	/**
	 * render
	 */
	public render(): any {
		return (
			<ul className="p-tab-bar">
				{this.props.list.map((val: string, idx: number): any => (
					<li key={idx} className={this.props.select === idx ? 'act' : ''} onClick={(): void => this.props.onChange && this.props.onChange(idx)}>
						{val}
					</li>
				))}
			</ul>
		);
	}
}

export default TabBar;
